import React, { createContext, useState, useContext } from "react";
import secureLocalStorage from "react-secure-storage";
// Create a Context
const LanguageContext = createContext();

// Custom Hook for convenience
export const useLanguage = () => useContext(LanguageContext);

// Provider Component
export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(secureLocalStorage.getItem("language") || "mr");

    const changeLanguage = (lang) => {
        setLanguage(lang);
        secureLocalStorage.setItem("language", lang);
    };
    return (
        <LanguageContext.Provider value={{ language, changeLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};
